import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function uploadQuoteLogo(token:string, input: any): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('uploadQuoteLogo')
    .setMethod('POST')
    .setProps([{token: token, input: input}])
    .send();
}
